import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Auth = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    // CSRFトークン取得
    const csrf = async () => {
        try {
            await axios.get('http://localhost:8000/sanctum/csrf-cookie', {
                withCredentials: true,
            });
            console.log('CSRF cookie set successfully');
        } catch (error) {
            console.error('Failed to set CSRF cookie:', error);
        }
    };

    useEffect(() => {
        csrf(); // 最初に一度だけCSRFトークンを取得
    }, []);

    // ログイン処理
    const handleLogin = async (e) => {
        e.preventDefault();
        await csrf(); // CSRFトークン取得
        try {
            const response = await axios.post('http://localhost:8000/login', { email, password }, {
                headers: {
                    'X-XSRF-TOKEN': decodeURIComponent(document.cookie.match(/XSRF-TOKEN=([^;]+)/)?.[1] || ''),
                },
                withCredentials: true,
            });

            localStorage.setItem('authToken', response.data.token);
            setMessage('ログイン成功！');
            console.log('ログイン成功:', response.data);

            // フロントエンドのダッシュボードにリダイレクト
            navigate('/dashboard');
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'ログインに失敗しました。';
            setMessage(errorMessage);
            console.error('ログインエラー:', errorMessage, error);
        }
    };

    return (
        <div>
            <h2>ログインフォーム</h2>
            <form onSubmit={handleLogin}>
                <div>
                    <label>メールアドレス</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>パスワード</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <button type="submit">ログイン</button>
            </form>
            {message && <p>{message}</p>}
        </div>
    );
};

export default Auth;
